import { IconArrowLeft } from '@bynder/icons';
import { Button, SkeletonList } from '@bynder/design-system';
import { StyledHeader } from '../shared/styled-components/Header';
import { StyledGuideContainer, StyledGuideContent } from './Styles';
import SkeletonPage from '../pages/SkeletonPage';
import { StyledChapterItem } from './Sidebar';
import { StyledNavigation } from '../shared/styled-components/Sidebar';
import { GuideType } from '../../types';

export const GuideSkeleton = () => {
  return (
    <>
      <StyledHeader>
        <Button
          variant="clean"
          icon={<IconArrowLeft aria-label="keyboard_arrow_left" />}
          onClick={() => {}}
          aria-label="Back"
        />
        <div style={{ width: '100%' }}>
          <SkeletonList.Item isThumbnailShow isSubtextShow />
        </div>
      </StyledHeader>
      <StyledGuideContainer $guideType={GuideType.MULTI_PAGE}>
        <StyledNavigation $isCollapsed={false}>
          <StyledChapterItem>
            <SkeletonList
              amount={3}
              itemRender={<SkeletonList.Item isSubtextShow />}
            />
            <SkeletonList
              amount={3}
              itemRender={<SkeletonList.Item isSubtextShow />}
            />
          </StyledChapterItem>
        </StyledNavigation>
        <StyledGuideContent>
          <SkeletonPage />
        </StyledGuideContent>
      </StyledGuideContainer>
    </>
  );
};
